<div class="edit-wizard-book">
  <h3>Confirm Your Book Details</h3>
  <div class="book-cover">
    <app-file-drop [bookUrl]="_book ? _book.amazonImageUrl : defaultCoverImage"
      (loading)="isUploadingBookCover($event)" (bookUploadData)="bookCoverUpload($event)"
      (bookUploadError)="bookCoverUploadError($event)">
    </app-file-drop>

    @if (uploadError) {
      <div>{{uploadError}}</div>
    }

    @if (uploading) {
      <app-spinner label="Uploading"></app-spinner>
    }
  </div>
  <div class="book-details" [class]="{'promo-stack-version': type === 'promostack'}">
    @if (bookType === 'amazon') {
      <app-input-form
        [form]="editBookForm"
        [id]="bookComponents.link.key"
        [label]="bookComponents.link.label"
        [type]="bookComponents.link.type"
        [required]="bookComponents.link.required"
        (blurHappened)="linkBlurEvent()"
        (keydown)="linkKeyDownEvent($event)">
      </app-input-form>
    }
    <ng-content></ng-content>

    <app-input-form [form]="editBookForm" [id]="bookComponents.title.key" [label]="bookComponents.title.label"
      [type]="bookComponents.title.type" [required]="bookComponents.title.required">
    </app-input-form>
    @if (editBookForm.get('title').invalid) {
      <div class="error-container">
        <span>Book title is required and must be at least 3 characters.</span>
      </div>
    }

    <app-input-form [form]="editBookForm" [id]="bookComponents.author.key" [label]="bookComponents.author.label"
      [type]="bookComponents.author.type" [required]="bookComponents.author.required">
    </app-input-form>
    @if (editBookForm.get('author').invalid) {
      <div class="error-container">
        <span>Author is required and must be at least 3 characters.</span>
      </div>
    }

    <app-textarea-form
      [form]="editBookForm"
      [id]="bookComponents.description.key"
      [label]="bookComponents.description.label"
      [required]="bookComponents.description.required"
    [maxLength]="bookComponents.description.maxLength"></app-textarea-form>
    <div class="description-subtext" [ngClass]="{'alert': descriptionLength > 350}">
      <span>Must be 350 characters or less. Please don't copy from Amazon.</span>
      <span>{{descriptionLength}} characters</span>
    </div>

    @if (showPurchaserInfoFields) {
      <div>
        <app-input-form [form]="editBookForm" [id]="bookComponents.purchaserInfoFirstName.key"
          [label]="bookComponents.purchaserInfoFirstName.label" [type]="bookComponents.purchaserInfoFirstName.type"
          [required]="bookComponents.purchaserInfoFirstName.required">
        </app-input-form>
        <app-input-form [form]="editBookForm" [id]="bookComponents.purchaserInfoLastName.key"
          [label]="bookComponents.purchaserInfoLastName.label" [type]="bookComponents.purchaserInfoLastName.type"
          [required]="bookComponents.purchaserInfoLastName.required">
        </app-input-form>
        <app-input-form [form]="editBookForm" [id]="bookComponents.purchaserInfoEmail.key"
          [label]="bookComponents.purchaserInfoEmail.label" [type]="bookComponents.purchaserInfoEmail.type"
          [required]="bookComponents.purchaserInfoEmail.required">
        </app-input-form>
      </div>
    }

    <app-input-form class="promo-wizard-input price" [form]="editBookForm" [id]="bookComponents.promoPrice.key"
      [min]="0"
      [label]="bookComponents.promoPrice.label" [type]="bookComponents.promoPrice.type"
      [required]="bookComponents.promoPrice.required"
      >
    </app-input-form>
    @if (editBookForm.get('promo_price').invalid) {
      <div class="error-container">
        <span>Promo Price is required and should be a number greater than or equal to zero.</span>
      </div>
    }
    @if (priceError) {
      <span class="error-text">
        Your book does not match the price requirements for this {{ type === 'promostack' ? 'Promo Stack' : 'Promotion'}}.
        Please update or consider purchasing a different {{ type === 'promostack' ? 'Promo Stack' : 'Promotion'}}.
      </span>
    }

    <toggle-switch [id]="bookComponents.kindleUnlimited.key" [label]="bookComponents.kindleUnlimited.label" [form]="editBookForm">
    </toggle-switch>
    <toggle-switch [id]="bookComponents.kindleCountdownDeal.key" [label]="bookComponents.kindleCountdownDeal.label" [form]="editBookForm">
    </toggle-switch>

    <app-input-form [form]="editBookForm" [id]="bookComponents.bookLength.key" [label]="bookComponents.bookLength.label"
      [type]="bookComponents.bookLength.type" [required]="bookComponents.bookLength.required"
      [min]="bookComponents.bookLength.min">
    </app-input-form>

    <toggle-switch [id]="bookComponents.isSeries.key" [label]="bookComponents.isSeries.label" [form]="editBookForm"></toggle-switch>
    @if (editBookForm.value.isSeries === true) {
      <div>
        <h6>Series Info</h6>
        <app-input-form [form]="editBookForm" [id]="bookComponents.nameOfSeries.key"
          [label]="bookComponents.nameOfSeries.label" [type]="bookComponents.nameOfSeries.type"
          [required]="bookComponents.nameOfSeries.required">
        </app-input-form>
        <app-input-form [form]="editBookForm" [id]="bookComponents.numberOfBooksInSeries.key"
          [label]="bookComponents.numberOfBooksInSeries.label" [type]="bookComponents.numberOfBooksInSeries.type"
          [required]="bookComponents.numberOfBooksInSeries.required" [min]="bookComponents.numberOfBooksInSeries.min">
        </app-input-form>
        <app-input-form [form]="editBookForm" [id]="bookComponents.bookNumber.key" [label]="bookComponents.bookNumber.label"
          [type]="bookComponents.bookNumber.type" [required]="bookComponents.bookNumber.required"
          [min]="bookComponents.bookNumber.min">
        </app-input-form>
      </div>
    }
    <h6>Links</h6>

    <!-- <app-input-form [form]="editBookForm" [id]="bookComponents.amazonLink.key" [label]="bookComponents.amazonLink.label"
    [type]="bookComponents.amazonLink.type" [required]="bookComponents.amazonLink.required">
  </app-input-form> -->
  <div class="form-group" [formGroup]="editBookForm">
    <label class="form-label" [for]="bookComponents.amazonLink.key">{{bookComponents.amazonLink.label}}</label>
    <input
      class="form-control"
      [id]="bookComponents.amazonLink.key"
      type="text"
      formControlName="amazonLink"
      [required]="bookComponents.amazonLink.required"
      >
    @if (editBookForm.controls.amazonLink.errors?.pattern) {
      <span class="form-error">Invalid Amazon link format</span>
    }
  </div>

  <div #authorstoreField id="{{ bookComponents.authorstore.key+'_field' }}" class="toggle-input">
    <div class="toggle-input-wrap">
      <app-input-form [form]="editBookForm" [id]="bookComponents.authorstore.key" [label]="bookComponents.authorstore.label"
        [type]="bookComponents.authorstore.type" [required]="bookComponents.authorstore.required">
      </app-input-form>

      <span class="deleteButton" (click)="deleteInput(bookComponents.authorstore.key)">
        &#10006;
      </span>
    </div>
  </div>

  <div #appleField id="{{ bookComponents.apple.key+'_field' }}" class="toggle-input">
    <div class="toggle-input-wrap">
      <app-input-form [form]="editBookForm" [id]="bookComponents.apple.key" [label]="bookComponents.apple.label"
        [type]="bookComponents.apple.type" [required]="bookComponents.apple.required">
      </app-input-form>

      <span class="deleteButton" (click)="deleteInput(bookComponents.apple.key)">
        &#10006;
      </span>
    </div>
  </div>

  <div #nookField id="{{ bookComponents.nook.key+'_field' }}" class="toggle-input">
    <div class="toggle-input-wrap">
      <app-input-form [form]="editBookForm" [id]="bookComponents.nook.key" [label]="bookComponents.nook.label"
        [type]="bookComponents.nook.type" [required]="bookComponents.nook.required">
      </app-input-form>

      <span class="deleteButton" (click)="deleteInput(bookComponents.nook.key)">
        &#10006;
      </span>
    </div>
  </div>

  <div #koboField id="{{ bookComponents.kobo.key+'_field' }}" class="toggle-input">
    <div class="toggle-input-wrap">
      <app-input-form [form]="editBookForm" [id]="bookComponents.kobo.key" [label]="bookComponents.kobo.label"
        [type]="bookComponents.kobo.type" [required]="bookComponents.kobo.required">
      </app-input-form>

      <span class="deleteButton" (click)="deleteInput(bookComponents.kobo.key)">
        &#10006;
      </span>
    </div>
  </div>

  <div #googleplayField id="{{ bookComponents.googleplay.key+'_field' }}" class="toggle-input">
    <div class="toggle-input-wrap">
      <app-input-form [form]="editBookForm" [id]="bookComponents.googleplay.key" [label]="bookComponents.googleplay.label"
        [type]="bookComponents.googleplay.type" [required]="bookComponents.googleplay.required">
      </app-input-form>

      <span class="deleteButton" (click)="deleteInput(bookComponents.googleplay.key)">
        &#10006;
      </span>
    </div>
  </div>

  <div class="toggle-links">
    @if (authorStoreEnabled || type === 'promostack') {
      <div class="add-link" (click)="addInput('authorstore')">+ Author Store</div>
    }
    <div class="add-link" (click)="addInput('apple')">+ Apple Books</div>
    <div class="add-link" (click)="addInput('nook')">+ Nook</div>
    <div class="add-link" (click)="addInput('kobo')">+ Kobo</div>
    <div class="add-link" (click)="addInput('googleplay')">+ Google Play</div>
  </div>

  <div class="margin">
    <toggle-switch [id]="bookComponents.subscribe.key" [label]="bookComponents.subscribe.label" [form]="editBookForm"></toggle-switch>
  </div>

  @if (seriesEnabled && type !== 'promostack') {
    <div class="seriesInfo">
      <button class="btn" (click)="addSeriesInfo()">Add Book To This Series</button>
      @for (seriesBook of seriesInfo; track seriesBook) {
        <div class="flex">
          <div>
            <label>Amazon Link</label>
            <input [value]="seriesBook.link" (change)="triggerSeriesUpdate()">
          </div>
          <div>
            <label for="seriesPrice">Price</label>
            <input [value]="seriesBook.price" (change)="triggerSeriesUpdate()">
          </div>
        </div>
      }
    </div>
  }

  <div class="flex">
    <div class="terms">
      <div [formGroup]="editBookForm">
        <input
          id="terms"
          [value]="editBookForm.value.terms"
          type="checkbox"
          formControlName="terms"
          class="form-control left"
          >
      </div>

      By checking this box, you agree to Written Word Media's
      <a href = 'https://www.writtenwordmedia.com/terms' target="_blank">Terms of Service</a> and
      <a href="https://www.writtenwordmedia.com/terms" target="_blank">Privacy Policy</a>
    </div>
  </div>
</div>

<div style="clear: both;"></div>
</div>
